// SQLite JSON1 operator lattice.
// PRD: Ralph/JsonColumnSemantics/PRD.md § Slice C2 (sqlite row).
//
// SQLite has no native JSON type — JSON columns reach the suggester through
// `check-isjson` (CHECK json_valid), `loose-json-declared`, or
// `loose-json-inferred`. JSON1 ships `->` / `->>` operators (3.38+) plus the
// `json_extract` / `json_valid` / `json_each` function family.

import type { Operator } from '../types';

const SQLITE_JSON: readonly Operator[] = Object.freeze([
  { token: '=', label: 'equals', snippetTemplate: "= '${1:value}'" },
  { token: '<>', label: 'not equals', snippetTemplate: "<> '${1:value}'" },
  { token: 'IS NULL', label: 'is null', snippetTemplate: 'IS NULL' },
  { token: 'IS NOT NULL', label: 'is not null', snippetTemplate: 'IS NOT NULL' },
  {
    token: '->',
    label: 'extract path (returns JSON)',
    snippetTemplate: "-> '${1:$.path}'",
    docsUrl: 'https://www.sqlite.org/json1.html#jptr',
    requiresPath: true,
  },
  {
    token: '->>',
    label: 'extract path (returns SQL value)',
    snippetTemplate: "->> '${1:$.path}'",
    docsUrl: 'https://www.sqlite.org/json1.html#jptr',
    requiresPath: true,
  },
  {
    token: 'json_extract',
    label: 'extract value at path',
    snippetTemplate: "json_extract(${1:col}, '${2:$.path}') = '${3:value}'",
    docsUrl: 'https://www.sqlite.org/json1.html#jex',
    requiresPath: true,
  },
  {
    token: 'json_valid',
    label: 'is well-formed JSON',
    snippetTemplate: 'json_valid(${1:col})',
    docsUrl: 'https://www.sqlite.org/json1.html#jvalid',
  },
  {
    token: 'EXISTS json_each',
    label: 'JSON contains matching element',
    snippetTemplate: 'EXISTS (SELECT 1 FROM json_each(${1:col}) WHERE ${2:value} = ${3:expected})',
    docsUrl: 'https://www.sqlite.org/json1.html#jeach',
  },
]);

export function sqliteJsonOperatorsFor(): readonly Operator[] {
  return SQLITE_JSON;
}
